import React, { type PropsWithChildren, useState, useCallback, useRef } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { FeedbackButton } from '../../../common/ui/feedback-button/index.tsx';
import { usePromptId } from '../../../controllers/prompt-state/index.tsx';
import messages from './messages.tsx';

export const ReportToAtlassianButton = ({ children }: PropsWithChildren<{}>) => {
	const hasOpened = useRef(false);
	const [isSubmitted, setSubmitted] = useState(false);
	const [promptId] = usePromptId();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const onClick = useCallback(() => {
		// Only emit analytics event first time popup is opened
		if (!hasOpened.current) {
			fireTrackAnalytics(createAnalyticsEvent({}), 'aiFeedback submitted', {
				aiFeatureName: 'NL Search in Jira',
				singleInstrumentationID: promptId,
				proactiveAIGenerated: 0,
				userGeneratedAI: 1,
				isAIFeature: 1,
				aiFeedbackResult: 'down',
			});
		}
		hasOpened.current = true;
	}, [createAnalyticsEvent, promptId]);

	const onSubmit = useCallback(() => setSubmitted(true), []);

	return isSubmitted ? null : (
		<FeedbackButton
			appearance="link"
			isErrorReport
			isDisabled={isSubmitted}
			isPositive={false}
			onClick={onClick}
			onSubmit={onSubmit}
			offset={[8, 16]}
			placement="bottom-end"
			spacing="none"
			label={
				typeof children === 'string' ? children : formatMessage(messages.reportToAtlassianDefault)
			}
		>
			{children}
		</FeedbackButton>
	);
};
